import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import './ContentWrapper.scss';

const ContentWrapper: FCX = ({
    children,
    style,
    className,
    testId,
}) => {
    return (
        <div
            className={cn("ContentWrapper", className)}
            style={style}
            data-testid={testId}
        >
            {children}
        </div>
    );
}

export default ContentWrapper;